define(function (require, exports, module) {
    'use strict';

    var app = require('Cloud/Application/app');
    var features = require('Cloud/Application/Features');
    var UploadReason = require('../UploadReason');
    var BrowserFileSizeLimitFail = require('../fails/BrowserFileSizeLimitFail');
    var UserNoAuthFail = require('../fails/UserNoAuthFail');

    var GB = 1024 * 1024 * 1024;

    /**
     * @namespace
     */
    var env = {
        /**
         * IE10 и IE11 не поддерживают загрузку файлов размером больше 4GB.
         * @url https://blogs.msdn.microsoft.com/ieinternals/2011/03/10/file-upload-and-download-limits/
         * @type {number}
         */
        MAX_TRIDENT_FILE_SIZE: 4 * GB,

        /**
         * Сведений о максимальном размере загружаемого файла в Edge не нашлось,
         * но выполнить загрузку файла больше 4GB не удалось,
         * а при попытке создать инстанс FormData больше 4GB
         * возникает ошибка: "Arithmetic result exceeded 32 bits".
         * @type {number}
         */
        MAX_EDGE_FILE_SIZE: features.getFeatureParam('newUpload', 'maxEdgeFileSize', 4) * GB,

        /**
         * @type {boolean}
         */
        isMacOS: navigator.platform === 'MacIntel',

        /**
         * @type {boolean}
         */
        isTrident: navigator.userAgent.indexOf('Trident/') !== -1,

        /**
         * @type {boolean}
         */
        isEdge: navigator.userAgent.indexOf('Edge/') !== -1,

        /**
         * @type {boolean}
         */
        isFirefox: navigator.userAgent.indexOf('Firefox/') !== -1,

        /**
         * @param {number} size – in bytes
         * @returns {Promise}
         * @resolves {number} – size
         * @rejects {UploadReason|Error}
         */
        checkFileSizeLessThanBrowserLimit: function (size) {
            var promise;

            if ((env.isTrident && size > env.MAX_TRIDENT_FILE_SIZE) || (env.isEdge && size > env.MAX_EDGE_FILE_SIZE)) {
                var source = UploadReason.SOURCE_WEB_CLIENT;
                var stack = new Error('BrowserFileSizeLimitFail');
                var reason = new BrowserFileSizeLimitFail(stack, source);

                promise = Promise.reject(reason);
            } else {
                promise = Promise.resolve(size);
            }

            return promise;
        },

        /**
         * @param {number} size – in bytes
         * @returns {Promise}
         * @resolves {number} – size
         * @rejects {UploadReason|Error}
         */
        checkFileSizeLessThanLimit: function (size) {
            var promise = env.checkFileSizeLessThanBrowserLimit(size);

            return promise;
        },

        checkUserAuth: function () {
            var promise;
            var email = app.user.getEmail();

            if (!email) {
                var source = UploadReason.SOURCE_WEB_CLIENT;
                var stack = new Error('UserNoAuthFail');
                var reason = new UserNoAuthFail(stack, source);

                promise = Promise.reject(reason);
            } else {
                promise = Promise.resolve(email);
            }

            return promise;
        },
    };

    module.exports = env;
});
